// extracted by mini-css-extract-plugin
export default {"wrapper":"Detail_wrapper__wPkyp","col":"Detail_col__QtUsl"};